module.exports = __webpack_public_path__ + "img/gift4-01-c03-t1.29a35d99.png";